export default "__VITE_ASSET__x8paY9hK__"